import { z } from "zod";
import { MetaSchema } from "./shared";

const WithdrawProfitOverviewSchema = z.object({
  overView: z.object({
    lastmonth: z.string(),
    lastthreemonths: z.string(),
    lasttwelvemonths: z.string(),
    totalamount: z.string(),
    totalcount: z.string(),
  }),
});

const WithdrawProfitWalletSchema = z.object({
  id: z.string().uuid(),
  investAmount: z.string(),
  balance: z.string(),
  equityBalance: z.string(),
  gGold: z.string(),
  dailyProfit: z.string(),
  profitCanWithdraw: z.string(),
  matchingReward: z.string(),
  address: z.string(),
  createdAt: z.string().datetime(),
  investUpdatedAt: z.string().datetime(),
});

const WithdrawProfitTransactionSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string().nullable(),
  type: z.string().nullable(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.number().nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  created_at: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  status: z.string(),
  description: z.string().nullable(),
  wallet: WithdrawProfitWalletSchema,
});

const WithdrawProfitHistoryItemSchema = z.object({
  week: z.string(),
  deposits: z.tuple([z.array(WithdrawProfitTransactionSchema), z.number()]),
});

const UsersWithdrawProfitResponse = z.object({
  data: z.union([
    WithdrawProfitOverviewSchema,
    z.array(WithdrawProfitHistoryItemSchema),
    z.tuple([z.array(WithdrawProfitTransactionSchema), z.number()]),
  ]),

  meta: MetaSchema.default,
});

export type UsersWithdrawProfitResponseType = z.infer<
  typeof UsersWithdrawProfitResponse
>;

export type UsersWithdrawProfitTransactionType = z.infer<
  typeof WithdrawProfitTransactionSchema
>;

export type WithdrawProfitOverviewResponseType = z.infer<
  typeof WithdrawProfitOverviewSchema
>;

export type WithdrawProfitHistoryResponseType = z.infer<
  typeof WithdrawProfitHistoryItemSchema
>;
export default UsersWithdrawProfitResponse;
